import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { Card } from "primereact/card";
import { trainingApi } from "../../services";

const EmpTrfDetailsView = ({ clickedRowData }) => {
  const user = useSelector(selectUser);
  const [currentstatus, setCurrentstatus] = useState();

  useEffect(() => {
    fetchEngagement();
    const empIndex = user.roles.indexOf('PM');
  }, []);

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      let proStatus = resp?.data?.data.find(item => item.id === clickedRowData?.status);
      setCurrentstatus(proStatus?.title);
    });
  };

  return (
    <>
      <hr />
      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Participant Name :</div>
            <div className='col'>
              {clickedRowData?.userName ? clickedRowData?.userName : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Current Status Of Participant :</div>
            <div className='col'>
              {currentstatus}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Project Name :</div>
            <div className='col'>
              {clickedRowData?.projectName ? clickedRowData?.projectName : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Type :</div>
            <div className='col'>
              {clickedRowData?.trainingType ? clickedRowData?.trainingType : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Category Of Training :</div>
            <div className='col'>
              {clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Requisition Date :</div>
            <div className='col'>
              {clickedRowData?.startDate ? moment(clickedRowData?.startDate).format("DD-MM-YYYY") : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>End Date for Training :</div>
            <div className='col'>
              {clickedRowData?.endDate ? moment(clickedRowData?.endDate).format("DD-MM-YYYY") : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Hours :</div>
            <div className='col'>
              {clickedRowData?.NoOfHours ? clickedRowData?.NoOfHours : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Complete(In Percentage) :</div>
            <div className='col'>
              {clickedRowData?.percentage ? clickedRowData?.percentage : 'Not Updated Yet'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Manager Validation Status :</div>
            <div className='col'>
              {clickedRowData?.isManagerValidate ? "YES" : "NO"}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Manager Feedback Status :</div>
            <div className='col'>
              {clickedRowData?.isManagerFeedback ? "YES" : "NO"}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Improvement Area(Comment) :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.trainingLearning ? clickedRowData?.trainingLearning : '-'}</Card>
            </div>
          </div>
          <div className="col-6">
            <div className='col trf-Detail-Label'>Module-Specific Details :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.learningApplyOnProject ? clickedRowData?.learningApplyOnProject : '-'}</Card>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}
export default EmpTrfDetailsView;
